import {IngenierosAgronomosActions, IngenierosAgronomosActionTypes} from './ingenieros-agronomos.actions';
import {ingenierosAgronomosAdapter, IngenierosAgronomosState, initialState} from './ingenieros-agronomos.state';

export function ingenierosAgronomosReducer(
  state = initialState,
  action: IngenierosAgronomosActions
): IngenierosAgronomosState {
  switch (action.type) {
    // load
    case IngenierosAgronomosActionTypes.INGENIEROSAGRONOMOS_LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case IngenierosAgronomosActionTypes.INGENIEROSAGRONOMOS_LOAD_SUCCESS: {
      return ingenierosAgronomosAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case IngenierosAgronomosActionTypes.INGENIEROSAGRONOMOS_LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // default
    default: {
      return state;
    }
  }
}
